import { IApplicationState } from '../../types/redux';

export const defaultState: IApplicationState['newbuildingsSearchUrl'] = null;

export function newbuildingsSearchUrlReducer(
  state: IApplicationState['newbuildingsSearchUrl'] = defaultState,
): IApplicationState['newbuildingsSearchUrl'] {
  return state;
}
